import {
    MOSCOW_PATIENT_VALIDATION_FAILED,
    MOSCOW_PATIENT_VALIDATION_SUCCESS, MOSCOW_SCENARIO_CLEAR_ERROR,
    MOSCOW_SCENARIO_LOAD_DOCTOR_NAMES_FAILED,
    MOSCOW_SCENARIO_LOAD_DOCTOR_NAMES_SUCCESS,
    MOSCOW_SCENARIO_LOAD_MEDICAL_ORGANISATION_FAILED,
    MOSCOW_SCENARIO_LOAD_MEDICAL_ORGANISATION_SUCCESS,
    MOSCOW_SCENARIO_ORDER_ID_FAILED,
    MOSCOW_SCENARIO_ORDER_ID_SUCCESS,
    MOSCOW_SCENARIO_REGIONS_BANS_FOUND,
    MOSCOW_SCENARIO_REGIONS_BANS_NOT_FOUND,
    MOSCOW_SCENARIO_SELECT_DOCTOR_NAME,
    MOSCOW_SCENARIO_SELECT_SPECIALITY,
    MOSCOW_SPECIALITIES_LOADING_FAILED,
    MOSCOW_SPECIALITIES_LOADING_SUCCESS
} from "../actions/types";

const defaultState = {
    bans: true, //TODO: Поменять на null при разработки функционала для региона Москва 
    orderId: null,
    error: null,
    patientId: null,
    specialities: null,
    selectedSpeciality: null,
    doctorNames: null,
    selectedDoctorName: null,
    medicalOrganisation: null
}

const updateMoscowScenario = (state, action) => {
    if (!state) {
        return defaultState
    }

    switch (action.type) {
        case MOSCOW_SCENARIO_REGIONS_BANS_FOUND:
            return {
                ...state.moscowScenario,
                bans: true
            }
        case MOSCOW_SCENARIO_REGIONS_BANS_NOT_FOUND:
            return {
                ...state.moscowScenario,
                bans: false
            }
        case MOSCOW_SCENARIO_ORDER_ID_SUCCESS:
            return {
                ...state.moscowScenario,
                orderId: action.payload
            }
        case MOSCOW_SCENARIO_ORDER_ID_FAILED:
            return {
                ...state.moscowScenario,
                error: action.payload
            }
        case MOSCOW_PATIENT_VALIDATION_SUCCESS:
            return {
                ...state.moscowScenario,
                patientId: action.payload
            }
        case MOSCOW_PATIENT_VALIDATION_FAILED:
            return {
                ...state.moscowScenario,
                error: action.payload
            }
        case MOSCOW_SPECIALITIES_LOADING_SUCCESS:
            return {
                ...state.moscowScenario,
                specialities: action.payload
            }
        case MOSCOW_SPECIALITIES_LOADING_FAILED:
            return {
                ...state.moscowScenario,
                error: action.payload
            }
        case MOSCOW_SCENARIO_SELECT_SPECIALITY:
            return {
                ...state.moscowScenario,
                selectedSpeciality: action.payload
            }
        case MOSCOW_SCENARIO_LOAD_DOCTOR_NAMES_SUCCESS:
            return {
                ...state.moscowScenario,
                doctorNames: action.payload
            }
        case MOSCOW_SCENARIO_LOAD_DOCTOR_NAMES_FAILED:
            return {
                ...state.moscowScenario,
                error: action.payload
            }
        case MOSCOW_SCENARIO_SELECT_DOCTOR_NAME:
            return {
                ...state.moscowScenario,
                selectedDoctorName: action.payload
            }
        case MOSCOW_SCENARIO_LOAD_MEDICAL_ORGANISATION_SUCCESS:
            return {
                ...state.moscowScenario,
                medicalOrganisation: action.payload
            }
        case MOSCOW_SCENARIO_LOAD_MEDICAL_ORGANISATION_FAILED:
            return {
                ...state.moscowScenario,
                error: action.payload,
                medicalOrganisation: null
            }
        case MOSCOW_SCENARIO_CLEAR_ERROR:
            return {
                ...state.moscowScenario,
                error: null
            }
        default:
            return {
                ...state.moscowScenario
            }
    }
}

export default updateMoscowScenario;
